<div class="progress-circle-container" [ngClass]="progressClass" (click)="onCircleClick($event)">
  <svg class="progress-svg" viewBox="0 0 100 100">
    <circle
      class="progress-ring-background"
      cx="50"
      cy="50"
      r="45"
      fill="none"
      stroke-width="8"
    />
    <circle
      class="progress-ring"
      [ngClass]="progressClass"
      cx="50"
      cy="50"
      r="45"
      fill="none"
      stroke-width="8"
      [attr.stroke-dasharray]="circumference"
      [attr.stroke-dashoffset]="strokeDashoffset"
      transform="rotate(-90 50 50)"
    />
  </svg>
  <div class="progress-content">
    <span class="progress-percentage">{{ progress }}%</span>
    <span class="progress-hint">{{ 'Settings::DataImport:ClickForDetails' | abpLocalization }}</span>
  </div>
</div>

